/**
 * Display limit constants for QuickSearchResults
 * These constants control how many items are shown in different result views
 */

/** Maximum hierarchy items (subdepartments + families) shown in mixed view */
export const MIXED_HIERARCHY_LIMIT = 5

/** Maximum cards (models/supermodels) shown in mixed view */
export const MIXED_CARD_LIMIT = 3

/** Maximum cards shown in full-page results view */
export const FULL_PAGE_CARD_LIMIT = 9

/** Maximum cards shown in single-view card grid */
export const SINGLE_CARD_LIMIT = 13

/** Grid column counts for CardSection component */
export const GRID_COLUMNS_MAP = {
  MODAL: MIXED_CARD_LIMIT, // 3
  FULL_PAGE: FULL_PAGE_CARD_LIMIT, // 9
  SINGLE_CATEGORY: Math.ceil(SINGLE_CARD_LIMIT / 2), // 7
} as const
